module.exports = __webpack_public_path__ + "img/slide1.c614f58b.jpg";